import { ValueIteratee, sortedIndexBy } from 'lodash';
import { DateRange, ChatSchedule } from './types';
import { Timestamp } from 'firebase/firestore';

export function getIsInRangeTester(range: DateRange) {
    if (range.startTime >= range.endTime) throw new Error('Invalid range');
    const ts_start = Timestamp.fromDate(range.startTime);
    const ts_end = Timestamp.fromDate(range.endTime);
    return function (schedule: ChatSchedule) {
        // Timestamp supports sensible valueOf
        return ts_start < schedule.endTime && schedule.startTime < ts_end;
    };
}

export function createScheduleFromRange(range: DateRange) {
    if (range.startTime >= range.endTime) throw new Error('Invalid date range');
    return {
        startTime: Timestamp.fromDate(range.startTime),
        endTime: Timestamp.fromDate(range.endTime),
    } as ChatSchedule;
}

// Get range for given month, uses human months, not js months
export function getRangeForMonth(year: number, month: number) {
    return {
        startTime: new Date(year, month - 1, 1),
        endTime: new Date(year, month, 1),
    } as DateRange;
}

// Get range for given day
export function getRangeForDay(date: Date) {
    return {
        startTime: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        endTime: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
    } as DateRange;
}

export function getFullDay(date: Date) {
    const year = date.getFullYear();
    const jsMonth = date.getMonth();
    const day = date.getDate();
    return {
        startTime: new Date(year, jsMonth, day),
        endTime: new Date(year, jsMonth, day + 1),
    } as DateRange;
}

// Get available full hours as js Dates in a given day
export function getFullHours(date: Date) {
    const HOUR = 1000 * 60 * 60;
    const day = getFullDay(date);
    const ret = [] as Date[];
    let current = day.startTime;
    while (current < day.endTime) {
        ret.push(current);
        current = new Date(current.valueOf() + HOUR);
    }
    return ret;
}

export function getSchedulesForRange(sortedSchedules: ChatSchedule[], range: DateRange) {
    const [startIdx, endIdx] = getScheduleIndexesForRange(sortedSchedules, range);
    return sortedSchedules.slice(startIdx, endIdx);
}

export function getScheduleIndexesForRange(sortedSchedules: ChatSchedule[], range: DateRange) {
    const startRange = {
        startTime: Timestamp.fromDate(range.startTime),
        endTime: Timestamp.fromDate(range.startTime),
    } as ChatSchedule;
    const endRange = {
        startTime: Timestamp.fromDate(range.endTime),
        endTime: Timestamp.fromDate(range.endTime),
    } as ChatSchedule;
    const startIdx = sortedIndexBy(sortedSchedules, startRange, scheduleIteratee);
    const endIdx = sortedIndexBy(sortedSchedules, endRange, scheduleIteratee);
    return [startIdx, endIdx];
}
export const scheduleIteratee = (x: ChatSchedule) => x.startTime.valueOf() as ValueIteratee<ChatSchedule>;
export const idIteratee = 'id' as ValueIteratee<ChatSchedule>;
